import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

export const isOfferingIndependentObjective = (objective?: IKeyObjective): boolean =>
  objective?.isOfferingIndependent === 1

export const getKeyInitiativeProgramType = (
  keyObjective: string,
  keyObjectives: IKeyObjective[],
  programType: ProgramTypes
): ProgramTypes | null => {
  const selectedObjective = keyObjectives.find(
    (objective) =>
      objective.key === keyObjective &&
      (!objective.offerings ||
        objective.offerings.split(',').some((offering) => offering.trim() === programType))
  )

  return isOfferingIndependentObjective(selectedObjective) ? null : programType
}
